const UploadMediaModel = Backbone.Model.extend({

  defaults: {
    file_name: 'Media Item',
  },

  // call API with setup string
  sendEncodedImages(params, options) {
    // sendible connect method
    Sendible.Connect.uploadMedia('', params, (data) => {
      options.success(data);
    }, (data) => {
      options.error(data);
    });
  },

  processMultiParam(media, params) {
    let mediaIndex = 1;
    const base64ChunkLength = 5000; // bits in byte = 262144, bits divided by 6 (6 being number of bits in base 64 charactor) = 43690

    for (let index = 0; index < media.length; index += base64ChunkLength) {
      // add chunk to appropiate param property
      if (mediaIndex > 0) params[`media${mediaIndex}`] = media.substr(index, base64ChunkLength);
      mediaIndex++;
    }

    params.chunks = --mediaIndex;

    return params;
  },

  sync(method, model, options) {
    const _this = this;
    let fileReader = null;
    let encodedMedia = '';
    let fileName = '';
    let fileBase64 = null;
    let fileIndex = 0;
    let fileData = '';
    let params = {};

    if (method === 'create' || method === 'update') {
      const files = model.get('files');

      // if the model has a base64 value
      if (files[0].hasOwnProperty('base64')) {
        for (fileIndex = 0; fileIndex < files.length; fileIndex++) {
          // set file name and base64 string for image
          fileName = files[fileIndex].name.replace(/[^a-z0-9.]/gi, '_').toLowerCase();
          fileBase64 = files[fileIndex].base64;

          // setup encode string
          encodedMedia += `${fileName}|${fileBase64},`;
        }

        // remove the last comma
        encodedMedia = encodedMedia.substring(0, encodedMedia.length - 1);

        // set params and run API method
        if (files[0].hasOwnProperty('multipart') && files[0].multipart) {
          params = this.processMultiParam(encodedMedia, params);
        } else {
          params.media = encodedMedia;
        }

        this.sendEncodedImages(params, options);

        return;
      }

      // runs processing based on wether the modal images are local files or base64 files
      if (!options.hasOwnProperty('fileType') || options.fileType === 'localFile') {
        // initialise FileReader
        fileReader = new FileReader();

        // bind to the onload event
        fileReader.onload = _.bind((event) => {
          // set file name and base64 string for image
          fileName = files[fileIndex].name.replace(/[^a-z0-9.]/gi, '_').toLowerCase();
          fileBase64 = event.target.result.split(',')[1];
          // setup encode string
          encodedMedia += `${fileName}|${fileBase64},`;
          // move counter onto next file
          fileIndex++;
          // if there is a "next" file then run call for this else run the api call method
          if (fileIndex < files.length) {
            fileReader.readAsDataURL(files[fileIndex]);
          } else {
            // remove the last comma
            encodedMedia = encodedMedia.substring(0, encodedMedia.length - 1);
            // set params and run API method
            params.media = encodedMedia;
            _this.sendEncodedImages(params, options);
          }
        }, this);

        fileReader.readAsDataURL(files[fileIndex]);
      } else if (options.fileType && (options.fileType === 'base64File' || options.fileType === 'remoteFile')) {
        // loop files and add them to encodedMedia string
        _.each(files, (file) => {
          if (file.fileType == 'base64File') {
            if (file.fileBase64.indexOf(',') !== -1) {
              fileData = file.fileBase64.split(',')[1];
            } else {
              fileData = file.fileBase64;
            }
          } else {
            fileData = file.file_url;
          }

          encodedMedia += `${file.fileName}|${fileData},`;
        });

        // remove the last comma
        encodedMedia = encodedMedia.substring(0, encodedMedia.length - 1);
        // set params and run API method
        params.media = encodedMedia;
        this.sendEncodedImages(params, options);
      }
    }
  },

});

export default UploadMediaModel;
